import { COLORS } from './colors';

const DECAY = 0.95;
const COLOR_A = COLORS.green.light;
const COLOR_B = COLORS.green.DEFAULT;

export default class Explosion {
    constructor({ multiplier, x, y, velocity }) {
        this.x = x;
        this.y = y;
        this.multiplier = multiplier;
        this.velocity = velocity;
    }

    setup = ({ dpr }) => {
        this.power = 1;
        this.r = 1 * dpr;
        this.pi2 = Math.PI * 2;
        this.opacity = 0.5;
    };

    update = () => {
        this.r += this.power;
        this.power *= DECAY;

        this.x += this.velocity.x;
        this.y += this.velocity.y;

        this.velocity.x *= DECAY;
        this.velocity.y *= DECAY;

        if (this.power < 0.01) {
            this.dead = true;
        }
    };

    draw = ({ ctx, dpr }) => {
        const color = ctx.createRadialGradient(
            this.x,
            this.y,
            this.r * (this.multiplier * this.power),
            this.x,
            this.y,
            this.r * this.multiplier
        );
        color.addColorStop(0, COLOR_A);
        color.addColorStop(1, COLOR_B);

        ctx.fillStyle = color;
        ctx.globalAlpha = this.opacity * this.power;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.r * this.multiplier, 0, this.pi2, true);
        ctx.closePath();
        ctx.fill();
        ctx.globalAlpha = 1;
    };
}
